import React from "react"

function Pagination({
  currentPage,
  goToPage,
  totalEntries,
  entriesPerPage = 50,
}) {
  const totalPages = Math.ceil(totalEntries / entriesPerPage)
  const results =
    currentPage < totalPages ? currentPage * entriesPerPage : totalEntries

  const getPageNumbers = () => {
    let pages = [];
    
    if (totalPages <= 3) {
      // Less than 3 pages, show all
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 2) {
      // Near the start
      pages = [1, 2, 3];
    } else if (currentPage >= totalPages - 1) {
      // Near the end
      pages = [totalPages - 2, totalPages - 1, totalPages];
    } else {
      // In the middle
      pages = [currentPage - 1, currentPage, currentPage + 1];
    }
    
    return pages;
  };

  const renderPageNumbers = () => {
    return getPageNumbers().map(pageNum => (
      <li key={pageNum} className="mx-0.5">
        <button
          onClick={() => goToPage(pageNum)}
          className={`w-8 h-8 text-xs rounded-full flex items-center justify-center focus:outline-none transition-colors ${
            currentPage === pageNum
              ? "bg-yellow-300 text-white"
              : "text-gray-700 hover:bg-gray-200"
          }`}
          aria-current={currentPage === pageNum ? "page" : undefined}
        >
          {pageNum}
        </button>
      </li>
    ));
  };

  if (totalPages === 0) {
    return null;
  }

  return (
    <div className="w-full py-2">
      <div className="flex flex-col sm:flex-row justify-between items-center px-2 sm:px-3 py-2 text-sm">
        <p className="text-gray-600 mb-2 sm:mb-0">
          {totalEntries
            ? `Showing ${(currentPage - 1) * entriesPerPage + 1}-${results} of ${totalEntries} results`
            : `Showing 0 of ${totalEntries} results`}
        </p>
        
        <nav aria-label="Pagination" className="flex justify-center">
          <ul className="flex items-center">
            {/* First page and previous buttons */}
            {currentPage > 1 && (
              <>
                <li className="mx-0.5">
                  <button
                    onClick={() => goToPage(1)}
                    className="w-8 h-8 text-xs rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-200 focus:outline-none transition-colors"
                    aria-label="Go to first page"
                  >
                    <i className="ph-caret-double-left"></i>
                  </button>
                </li>
                <li className="mx-0.5">
                  <button
                    onClick={() => goToPage(currentPage - 1)}
                    className="w-8 h-8 text-xs rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-200 focus:outline-none transition-colors"
                    aria-label="Go to previous page"
                  >
                    <i className="ph-caret-left"></i>
                  </button>
                </li>
              </>
            )}

            {/* Page numbers */}
            {renderPageNumbers()}

            {/* Next and last page buttons */}
            {currentPage < totalPages && (
              <>
                <li className="mx-0.5">
                  <button
                    onClick={() => goToPage(currentPage + 1)}
                    className="w-8 h-8 text-xs rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-200 focus:outline-none transition-colors"
                    aria-label="Go to next page"
                  >
                    <i className="ph-caret-right"></i>
                  </button>
                </li>
                <li className="mx-0.5">
                  <button
                    onClick={() => goToPage(totalPages)}
                    className="w-8 h-8 text-xs rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-200 focus:outline-none transition-colors"
                    aria-label="Go to last page"
                  >
                    <i className="ph-caret-double-right"></i>
                  </button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default Pagination